import * as Switch from '@radix-ui/react-switch'
import { AgentConversationFormActions } from '../../../store/slice'
import { useAppDispatch } from '@/store/store-hooks'
import { researchFiltersActions } from '../../store/slice'
import WarningBanner from '../WarningBanner'

type StatesFilterOptionsProps = {
  conversationId: string
  hasSelectedStates: boolean
  includeRelatedFederalContent: boolean
  showWarningBanner: boolean
  setShowWarningBanner: (showWarningBanner: boolean) => void
  includeUnpublishedCases: boolean
}

export function StatesFilterOptions(props: StatesFilterOptionsProps) {
  const { conversationId, hasSelectedStates, includeRelatedFederalContent, showWarningBanner, setShowWarningBanner, includeUnpublishedCases } = props

  const dispatch = useAppDispatch()

  const handleIncludeFederalChange = () => {
    if (!hasSelectedStates) {
      setShowWarningBanner(true)
    }
    // Toggle related federal content in researchFiltersState to true to show warning banner
    dispatch(researchFiltersActions.toggleRelatedFederalContent({ conversationId, enabled: !includeRelatedFederalContent }))
  }

  const handleIncludeUnpublishedCasesChange = (includeUnpublishedCases: boolean) => {
    // Dispatch action to set the include unpublished cases value to request params
    dispatch(AgentConversationFormActions.setIncludeUnpublishedCases({ conversationId: conversationId, includeUnpublishedCases: includeUnpublishedCases }))
  }

  return (
    // Sticky bottom of the states tabpanel with gradient background
    <div className="sticky bottom-0 left-0 right-0 z-10 bg-brand-neutral-50 md:px-4 md:pb-4">
      {/* Gradient background */}
      <div className="pointer-events-none absolute -top-6 left-0 right-0 h-6 bg-gradient-to-t from-white" />
      <div className="columns-1 border-t md:columns-2 md:border-b bg-white md:rounded-md mx-auto md:border md:border-brand-neutral-200">
        <div className="flex items-center h-[52px] md:h-full py-2.5 px-6 md:px-3.5 md:border-r border-brand-neutral-200">
          <label htmlFor="federal-content" className="flex items-center gap-2 text-sm font-normal text-brand-neutral-950">
            <Switch.Root
              id="federal-content"
              className="relative h-[25px] min-w-10 cursor-default rounded-full bg-brand-neutral-400 outline-none data-[state=checked]:bg-brand-500 transition-all duration-300"
              checked={includeRelatedFederalContent}
              onCheckedChange={() => handleIncludeFederalChange()}
            >
              <Switch.Thumb className="block size-5 translate-x-0.5 rounded-full bg-white transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[19px]" />
            </Switch.Root>
            Include related federal content
          </label>
        </div>

        <div className="flex items-center h-[52px] md:h-full py-2.5 px-6 md:px-3.5 border-t md:border-t-0 border-brand-neutral-200">
          <label htmlFor="unpublished-cases" className="flex items-center gap-2 text-sm font-normal text-brand-neutral-950">
            <Switch.Root
              id="unpublished-cases"
              className="relative h-[25px] min-w-10 cursor-default rounded-full bg-brand-neutral-400 outline-none data-[state=checked]:bg-brand-500 transition-all duration-300"
              checked={includeUnpublishedCases}
              onCheckedChange={(checked) => handleIncludeUnpublishedCasesChange(checked)}
            >
              <Switch.Thumb className="block size-5 translate-x-0.5 rounded-full bg-white transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[19px]" />
            </Switch.Root>
            Include unpublished case law
          </label>
        </div>
      </div>
      {showWarningBanner && (
        <div className="md:mt-4">
          <WarningBanner message="You must select a state source in order to include related federal content" />
        </div>
      )}
    </div>
  )
}
